/* eslint-disable no-loop-func */
import React from 'react';
import { Dialog, Text, Pane, Label, Selector } from '@leverege/ui-elements';
import { LoadingView } from '@leverege/molten/views';
import P from '@leverege/promise';
import { getLocations } from '../../util/Interface';
import { generateBillingReport } from '../../util/Billing';
import { MONTHS } from './Constants';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const years = [{
  name: '2021'
}, {
  name: '2022'
}];
export default class VehicleTransferLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numLocationsSelected: 0,
      month: '',
      year: ''
    };
  }
  async componentDidMount() {
    const {
      targets,
      systemId
    } = this.props;
    let locationCount = 0;
    const locations = [];
    await P.mapLimit(targets, async target => {
      const companyId = target.id;
      const companyName = target.data?.name;
      const res = await getLocations(systemId, companyId, {
        companyName
      });
      locationCount += res.length;
      locations.push(...res);
    }, {
      handleReject: false,
      limit: 2
    });
    this.setState({
      numLocationsSelected: locationCount,
      locations
    });
  }
  onValueChange = evt => {
    this.setState({
      [evt.data]: evt.value
    });
  };
  onOkay = async () => {
    const {
      onClose
    } = this.props;
    const {
      locations,
      month,
      year
    } = this.state;
    const closeLoading = LoadingView.showDialog('Generating Billing Report');
    generateBillingReport(locations, {
      month,
      year
    });
    onClose();
    closeLoading();
  };
  onCancel = () => {
    const {
      onClose
    } = this.props;
    onClose();
  };
  render() {
    const {
      show,
      onClose
    } = this.props;
    const {
      month,
      year,
      numLocationsSelected
    } = this.state;
    return /*#__PURE__*/_jsx(Dialog.Question, {
      show: show,
      onClose: onClose,
      icon: "https://recovr-ui-assets.storage.googleapis.com/location_details.png",
      title: "Generate Billing Report",
      okay: "Download Report",
      okayVariant: "primary",
      cancelVariant: "secondary",
      onOkay: this.onOkay,
      bodyVariant: "dialogBodyNoTopPad",
      okayDisabled: !(month && year),
      onCancel: this.onCancel,
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colM",
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "infoText",
          children: [numLocationsSelected, " Locations Selected"]
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputHeader",
          children: "Select Month and Year for Export"
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Month"
        }), /*#__PURE__*/_jsx(Selector, {
          eventData: "month",
          value: month,
          valueKey: "name",
          targetAttachment: "top right",
          onChange: this.onValueChange,
          values: MONTHS
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Year"
        }), /*#__PURE__*/_jsx(Selector, {
          value: year,
          valueKey: "name",
          eventData: "year",
          targetAttachment: "top right",
          onChange: this.onValueChange,
          values: years
        })]
      })
    });
  }
}